module.exports = __webpack_public_path__ + "img/background_c4-2-2.c95f9515.jpg";